// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__2l5oz","fullView":"styles_fullView__3_5Av"};